import { Box, Stack } from '@n26/nxd'
import { trackGTM } from '@helpers/core/trackGTM'
import { Text } from '@components/Text'
import { useCountryAwareSlugWithPrefix } from '@hooks/useCountryAwareSlugWithPrefix'
import { getBackgroundColor } from '@helpers/getBackgroundColor'
import { CountryAwareReadMore } from '@components/CountryAwareReadMore'
import type { LandingPageData } from '@pages/LandingPage'

type LandingPageBannerProps = {
  bannerData: LandingPageData['landingPageData']['banner']
}

export const LandingPageBanner = ({ bannerData }: LandingPageBannerProps) => {
  const hrefOrSlugWithPrefix = useCountryAwareSlugWithPrefix(
    bannerData?.readMore
  )

  if (!bannerData) {
    return null
  }

  const { backgroundColor, content, readMore } = bannerData
  const { label, externalLink } = readMore || {}
  const backgroundColorClassName = getBackgroundColor(backgroundColor)
  const isPDFDownload = externalLink?.includes('.pdf')

  const trackClick = () => {
    const trackingEvent = {
      event: 'banner_click',
      // eslint-disable-next-line camelcase
      destination_url: hrefOrSlugWithPrefix,
      text: content,
    }

    const trackPDFEvent = {
      event: 'pdf_download_click',
      text: label,
      // eslint-disable-next-line camelcase
      destination_url: externalLink,
    }

    trackGTM(trackingEvent)

    if (isPDFDownload) {
      trackGTM(trackPDFEvent)
    }
  }

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      className={`${backgroundColorClassName} top-0 h-[32px]`}
      id='landing-page-banner'
    >
      <Stack direction='horizontal' justify='center' align='center'>
        {readMore && hrefOrSlugWithPrefix ? (
          <CountryAwareReadMore readMore={readMore} onClick={trackClick}>
            <Text variant='x-small'>{content}</Text>
            <Box display={{ mobile: 'none', desktop: 'inline' }}>
              <Text variant='x-small-bold'>. {readMore.label}</Text>
            </Box>
          </CountryAwareReadMore>
        ) : (
          <Text variant='x-small'>{content}</Text>
        )}
      </Stack>
    </Box>
  )
}
